module.exports = __webpack_public_path__ + "static/media/yidongduanbeijingtu.c9d1a881.png";